export class ScalingModel {
  constructor(public methodName: string,
              public methodDescription: string) {
  }

}
